// App.js
import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { Helmet } from "react-helmet";
import SinglePageLayout from "./components/layout/SinglePageLayout";
import Unsubscribe from "./features/home/Unsubscribe";
import LoadingScreen from "./shared/components/LoadingScreen";
import SorteoPage from "./features/raffle/SorteoPage";

const App = () => {
  const [isLoading, setIsLoading] = useState(true); // Comenzar con loading activo
  const navigationType = useNavigationType();
  const location = useLocation();
  const initialLoadCompleted = useRef(false);

  useEffect(() => {
    // Para desarrollo: permitir resetear con ?reset=true
    if (process.env.NODE_ENV === 'development') {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('reset') === 'true') {
        setIsLoading(true);
        initialLoadCompleted.current = false;
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }
    }

    // Solo oculta el loading en navegaciones internas
    if ((navigationType === 'PUSH' || navigationType === 'REPLACE') && initialLoadCompleted.current) {
      // Si es navegación entre páginas internas y ya se ha completado la carga inicial, no mostrar loading
      setIsLoading(false);
    }
  }, [navigationType, location.pathname]);

  const handleLoadingComplete = () => {
    initialLoadCompleted.current = true;
    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>Zaquiel Comic</title>
        <meta
          name="description"
          content="Descubre Zaquiel Comic, una obra única llena de misterio y magia ambientada en los rincones más sorprendentes de Castilla y León. ¿Te atreves a explorarla?"
        />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>

      {isLoading ? (
        <LoadingScreen onLoadingComplete={handleLoadingComplete} />
      ) : (
        <Routes>
          <Route path="/sorteo" element={<SorteoPage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/*" element={<SinglePageLayout />} />
        </Routes>
      )}
    </>
  );
};

export default App;
